import React from 'react';
import styled from 'styled-components';
import { CircularProgress } from '@mui/material';

import Avatar from 'components/Avatar/Avatar';

export const StyledCircularProgress = styled(CircularProgress)`
  padding: 1rem;
  margin: 0 auto;
  border: none;
`;

export const UserMentionRow = styled.div<{ selected?: boolean }>`
  background-color: ${(props) => (props.selected ? props.theme.palette.action.hover : 'white')};
  color: black;
  display: flex;
  align-items: center;

  &:hover {
    background-color: ${({ theme }) => theme.palette.grey[50]};
  }
`;

export const Container = styled.div`
  max-height: 20em;
  overflow-y: auto;
  padding: -8px;
  position: absolute;
  width: 100%;
  bottom: 52px;
  background: white;
  ::-webkit-scrollbar {
    width: 0 !important;
  }
  -ms-overflow-style: none;
  border: 1px solid ${({ theme }) => theme.palette.grey[200]};
  border-radius: 8px;
`;

export const UserCellName = styled.p`
  text-decoration: none;
  margin-left: 6px;
  font-size: 1.4rem;
  line-height: 1.6rem;
  color: ${({ theme }) => theme.palette.primary.dark};
  border: none;
`;

export const UserCellAvatar = styled(Avatar)`
  margin-left: 8px;
  > img {
    width: 32px;
    height: 32px;
  }
  border: none;
`;

export const NoResults = styled.p`
  text-decoration: none;
  margin-left: 6px;
  font-size: 1.4rem;
  font-style: italic;
  line-height: 1.6rem;
  text-align: center;
  width: 100%;
  color: ${({ theme }) => theme.palette.primary.dark};
`;
